import { render, staticRenderFns } from "./StaticPagesLayout.vue?vue&type=template&id=a7b26200"
import script from "./StaticPagesLayout.vue?vue&type=script&lang=js"
export * from "./StaticPagesLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports